import { ProgressBarComponent } from './progress-bar/progress-bar.component';

export const Components = [
	ProgressBarComponent,
];
